exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-test-sentry-tsx": () => import("./../../../src/pages/test-sentry.tsx" /* webpackChunkName: "component---src-pages-test-sentry-tsx" */),
  "component---src-pages-thank-you-tsx": () => import("./../../../src/pages/thank-you.tsx" /* webpackChunkName: "component---src-pages-thank-you-tsx" */),
  "component---src-templates-dental-ad-1-tsx": () => import("./../../../src/templates/dental-ad-1.tsx" /* webpackChunkName: "component---src-templates-dental-ad-1-tsx" */)
}

